/** Единое название системы в UI, чеках и печати */
export const APP_NAME = 'Aurent';
